import React from 'react'

const UploadCv = () => (
	<svg width='138px' height='139px' viewBox='0 0 138 139'>
		<g
			id='My_profile_1'
			stroke='none'
			strokeWidth='1'
			fill='none'
			fillRule='evenodd'
		>
			<g
				id='Profile'
				transform='translate(-1100.000000, -281.000000)'
			>
				<g
					id='Group-9'
					transform='translate(852.000000, 177.000000)'
				>
					<g
						id='Group-5'
						transform='translate(23.000000, 83.000000)'
					>
						<g
							id='Group-6'
							transform='translate(196.000000, 21.936391)'
						>
							<g
								id='Upload-file'
								transform='translate(29.000000, 0.000000)'
							>
								<circle
									id='Oval'
									fill='#FAFAFA'
									cx='69'
									cy='69'
									r='69'
								></circle>
								<g
									id='Group-18'
									transform='translate(25.000000, 26.000000)'
								>
									<path
										d='M15.350119,11.5724405 L15.350119,63.0033929 C15.350119,64.2027976 16.3227381,65.1760119 17.5227381,65.1760119 L26.367381,65.1760119 L29.0197619,67.8289881 L29.0197619,69.9635119 L12.9560714,68.823631 L11.4739286,15.1379167 L15.350119,11.5724405 Z'
										id='Fill-1'
										fill='#E4E8F0'
									></path>
									<polygon
										id='Fill-3'
										fill='#E4E8F0'
										points='37.4233333 59.3269643 37.4233333 83.64125 34.4596429 83.64125 42.8667857 93.9501786 40.5661905 97.888869 26.367381 80.4495833 33.7757143 80.3352976 33.7757143 59.3269643'
									></polygon>
									<polygon
										id='Fill-5'
										fill='#E4E8F0'
										points='33.9464286 54.5767857 37.252381 54.5767857 37.252381 47.110119 33.9464286 47.110119'
									></polygon>
									<polygon
										id='Fill-7'
										fill='#E4E8F0'
										points='33.9464286 42.6380952 37.252381 42.6380952 37.252381 36.6452381 33.9464286 36.6452381'
									></polygon>
									<path
										d='M28.2616667,18.0285119 L16.6896429,18.0285119 C15.9497619,18.0285119 15.3503571,17.4291071 15.3503571,16.6892262 C15.3503571,15.9493452 15.9497619,15.3499405 16.6896429,15.3499405 L25.5830952,15.3499405 L25.5830952,6.45589286 C25.5830952,5.7160119 26.1830952,5.11660714 26.922381,5.11660714 C27.6616667,5.11660714 28.2616667,5.7160119 28.2616667,6.45589286 L28.2616667,18.0285119 Z'
										id='Fill-8'
										fill='#B0BAC9'
									></path>
									<path
										d='M64.443869,70.8995238 L52.5051786,70.8995238 C51.7658929,70.8995238 51.1658929,70.300119 51.1658929,69.5602381 C51.1658929,68.8203571 51.7658929,68.2209524 52.5051786,68.2209524 L64.443869,68.2209524 C65.586131,68.2209524 66.5152976,67.2911905 66.5152976,66.1495238 L66.5152976,4.75071429 C66.5152976,3.60845238 65.586131,2.67869048 64.443869,2.67869048 L25.77125,2.67869048 L12.9123214,15.5388095 L12.9123214,66.1495238 C12.9123214,67.2911905 13.8414881,68.2209524 14.98375,68.2209524 L28.6277976,68.2209524 C29.3670833,68.2209524 29.9670833,68.8203571 29.9670833,69.5602381 C29.9670833,70.300119 29.3670833,70.8995238 28.6277976,70.8995238 L14.98375,70.8995238 C12.3647024,70.8995238 10.23375,68.7685714 10.23375,66.1495238 L10.23375,14.4286905 L24.6623214,0.000119047619 L64.443869,0.000119047619 C67.0629167,0.000119047619 69.193869,2.13107143 69.193869,4.75071429 L69.193869,66.1495238 C69.193869,68.7685714 67.0629167,70.8995238 64.443869,70.8995238'
										id='Fill-9'
										fill='#B0BAC9'
									></path>
									<path
										d='M28.3541071,81.1327976 L40.8689881,96.3839881 L53.3844643,81.1327976 L47.3892262,81.1327976 C46.6493452,81.1327976 46.0499405,80.5333929 46.0499405,79.7935119 L46.0499405,60.6667262 L35.083869,60.6667262 L35.083869,79.7935119 C35.083869,80.5333929 34.483869,81.1327976 33.7445833,81.1327976 L28.3541071,81.1327976 Z M40.8689881,99.8345833 C40.4683929,99.8345833 40.088631,99.6548214 39.833869,99.3447024 L24.4874405,80.6429167 C24.158869,80.2429167 24.0904167,79.68875 24.3118452,79.2208929 C24.5332738,78.7524405 25.0047024,78.4542262 25.5225595,78.4542262 L32.4052976,78.4542262 L32.4052976,59.3274405 C32.4052976,58.5875595 33.0047024,57.9881548 33.7445833,57.9881548 L47.3892262,57.9881548 C48.1285119,57.9881548 48.7285119,58.5875595 48.7285119,59.3274405 L48.7285119,78.4542262 L56.2160119,78.4542262 C56.733869,78.4542262 57.2052976,78.7524405 57.4267262,79.2208929 C57.6481548,79.68875 57.5797024,80.2429167 57.251131,80.6429167 L41.9047024,99.3447024 C41.6499405,99.6548214 41.2701786,99.8345833 40.8689881,99.8345833 L40.8689881,99.8345833 Z'
										id='Fill-10'
										fill='#B0BAC9'
									></path>
									<path
										d='M35.0839286,52.8714286 L46.05,52.8714286 L46.05,48.7279762 L35.0839286,48.7279762 L35.0839286,52.8714286 Z M47.3886905,55.55 L33.7446429,55.55 C33.0047619,55.55 32.4053571,54.95 32.4053571,54.2107143 L32.4053571,47.3886905 C32.4053571,46.6488095 33.0047619,46.0494048 33.7446429,46.0494048 L47.3886905,46.0494048 C48.1285714,46.0494048 48.7279762,46.6488095 48.7279762,47.3886905 L48.7279762,54.2107143 C48.7279762,54.95 48.1285714,55.55 47.3886905,55.55 L47.3886905,55.55 Z'
										id='Fill-11'
										fill='#CFD7E1'
									></path>
									<path
										d='M35.0839286,40.9327381 L46.05,40.9327381 L46.05,38.4946429 L35.0839286,38.4946429 L35.0839286,40.9327381 Z M47.3886905,43.6113095 L33.7446429,43.6113095 C33.0047619,43.6113095 32.4053571,43.0119048 32.4053571,42.2720238 L32.4053571,37.1553571 C32.4053571,36.4160714 33.0047619,35.8160714 33.7446429,35.8160714 L47.3886905,35.8160714 C48.1285714,35.8160714 48.7279762,36.4160714 48.7279762,37.1553571 L48.7279762,42.2720238 C48.7279762,43.0119048 48.1285714,43.6113095 47.3886905,43.6113095 L47.3886905,43.6113095 Z'
										id='Fill-12'
										fill='#CFD7E1'
									></path>
									<path
										d='M86.6153571,40.2002976 C85.8760714,40.2002976 85.2760714,39.6008929 85.2760714,38.8610119 L85.2760714,3.04494048 C85.2760714,2.30505952 85.8760714,1.70565476 86.6153571,1.70565476 C87.3546429,1.70565476 87.9546429,2.30505952 87.9546429,3.04494048 L87.9546429,38.8610119 C87.9546429,39.6008929 87.3546429,40.2002976 86.6153571,40.2002976'
										id='Fill-13'
										fill='#E4E8F0'
									></path>
									<path
										d='M78.0878571,52.13875 C77.3485714,52.13875 76.7485714,51.5393452 76.7485714,50.7994643 L76.7485714,47.38875 C76.7485714,46.648869 77.3485714,46.0494643 78.0878571,46.0494643 C78.8271429,46.0494643 79.4271429,46.648869 79.4271429,47.38875 L79.4271429,50.7994643 C79.4271429,51.5393452 78.8271429,52.13875 78.0878571,52.13875'
										id='Fill-14'
										fill='#E4E8F0'
									></path>
									<path
										d='M78.0878571,43.61125 C77.3485714,43.61125 76.7485714,43.0118452 76.7485714,42.2719643 L76.7485714,38.86125 C76.7485714,38.121369 77.3485714,37.5219643 78.0878571,37.5219643 C78.8271429,37.5219643 79.4271429,38.121369 79.4271429,38.86125 L79.4271429,42.2719643 C79.4271429,43.0118452 78.8271429,43.61125 78.0878571,43.61125'
										id='Fill-15'
										fill='#E4E8F0'
									></path>
									<path
										d='M78.0878571,35.0835119 C77.3485714,35.0835119 76.7485714,34.4841071 76.7485714,33.7442262 L76.7485714,30.3335119 C76.7485714,29.593631 77.3485714,28.9942262 78.0878571,28.9942262 C78.8271429,28.9942262 79.4271429,29.593631 79.4271429,30.3335119 L79.4271429,33.7442262 C79.4271429,34.4841071 78.8271429,35.0835119 78.0878571,35.0835119'
										id='Fill-16'
										fill='#E4E8F0'
									></path>
									<path
										d='M1.33934524,76.0160119 C0.600059524,76.0160119 5.95238095e-05,75.4166071 5.95238095e-05,74.6767262 L5.95238095e-05,43.9773214 C5.95238095e-05,43.2380357 0.600059524,42.6380357 1.33934524,42.6380357 C2.07863095,42.6380357 2.67863095,43.2380357 2.67863095,43.9773214 L2.67863095,74.6767262 C2.67863095,75.4166071 2.07863095,76.0160119 1.33934524,76.0160119'
										id='Fill-17'
										fill='#B0BAC9'
									></path>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export default UploadCv
